import { render, staticRenderFns } from "./BeforeTurn.vue?vue&type=template&id=4eabbb12&scoped=true&lang=pug&"
import script from "./BeforeTurn.vue?vue&type=script&lang=js&"
export * from "./BeforeTurn.vue?vue&type=script&lang=js&"
import style0 from "./BeforeTurn.vue?vue&type=style&index=0&id=4eabbb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabbb12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eabbb12')) {
      api.createRecord('4eabbb12', component.options)
    } else {
      api.reload('4eabbb12', component.options)
    }
    module.hot.accept("./BeforeTurn.vue?vue&type=template&id=4eabbb12&scoped=true&lang=pug&", function () {
      api.rerender('4eabbb12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/BeforeTurn.vue"
export default component.exports